import { Injectable } from '@angular/core';
import { StoreBase } from '@stores/abstract';
import { Walkthrough } from '@stores/models';

@Injectable({ providedIn: 'root' })
export class WalkthroughStore extends StoreBase<Walkthrough> {
  override storeName = 'WalkthroughStore';
}
